import * as React from 'react';
import { LungVolumeSessionsListTable } from './LungVolumeSessionsListTable';
import DocumentTitle from '../misc/components/DocumentTitle';
import { ODataParams, Query } from '../Components/Query';
import { WebPortalClient } from 'webportalclient';
import { useCurrentStudyConfigurationContext } from '../Core/CurrentStudyConfigurationContext';
import { useWebPortalApiClient } from '../misc/api/WebPortalTokenClient';

export const LungVolumeSessionsListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getLungVolumeSessions(undefined, filter, params.orderby, 'visit($expand=subject($expand=site)),tests,analysisSets', params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="Lung Volume Sessions | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "occurred", condition: "desc" }]}>
                <LungVolumeSessionsListTable />
            </Query>
        </DocumentTitle>
    );
};
